import grapesjs from 'drapcode-builder';
import loadBlocks from './blocks';
import loadComponents from './components';
import loadTraits from './traits';
import { progress, progressBar, label_progress, label_progressBar, category } from './consts';

export default grapesjs.plugins.add('gjs-progress', (editor, opts = {}) => {
  let c = opts;

  let defaults = {
    blocks: [progress],
    defaultStyle: true,
    pfx: progress,
    label: label_progressBar,
    category: category,
  };
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  loadComponents(editor, c);
  loadBlocks(editor, c);
  loadTraits(editor, c);
});
